/**
 * ConsentFileTypeSelector
 *
 * Dropdown component to select a document file type.
 * - Fetches available types via `DocFileTypes.get()`.
 * - Filters only DOC mode types.
 * - Auto-selects the file matching `defaultFileName` or the first option.
 * - Syncs selected value with the parent Ant Design Form.
 *
 * @param {Object} props
 * @param {Object} props.form - Ant Design Form instance
 * @param {string} props.defaultFileName - Default file name to auto-select
 */


import React, { useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'soxo-bootstrap-core';
import { DocFileTypes } from '../../models';
import "./consent-uploader.scss";

const { Option } = Select;

const ConsentFileSelector = ({ form, onTypeChange, FlieTypeShow }) => {
    const { t } = useTranslation(); // To Translate to another language

    const [fileDetails, setFileDetails] = useState([]); // To store file details

    const [selectedType, setSelectedType] = useState(null); // Selected file type

    useEffect(() => {
        getFileDetails();
    }, []);


    // Fetches available file types from the API and filters the results based on document code.
    function getFileDetails() {
        DocFileTypes.get().then((result) => {
            const data = result.result.filter((value) => value.docft_code === FlieTypeShow );

            setFileDetails(data);

            // // Automatically select "Consent" as default
            const defaultItem = data.find((item) => item.docft_desc === FlieTypeShow) || data[0]; // fallback to first item if "Consent" not found

            if (defaultItem) {
                setSelectedType(defaultItem.docft_id);
                form.setFieldsValue({ fileType: defaultItem.docft_id, documentCode: defaultItem.docft_code });
            }

            const parsedOtherDetails = defaultItem?.docft_otherdetails
                ? JSON.parse(defaultItem.docft_otherdetails)
                : {};

            if (onTypeChange) {
                onTypeChange(defaultItem.docft_code, parsedOtherDetails);
            }

        });
    }

    // Handles the change event for the file type dropdown
    const handleChange = (value,option) => {
        const selected = option?.record || fileDetails.find((item) => item.docft_id === value);


        setSelectedType(value);
        form.setFieldsValue({ fileType: value, documentCode: selected?.docft_code });

        if (onTypeChange) {
        const parsedOtherDetails = selected?.docft_otherdetails
        ? JSON.parse(selected.docft_otherdetails)
        : {};

            onTypeChange(selected?.docft_code,parsedOtherDetails ); // send selected code (e.g., CST, EMID)
        }
    };

    return (
        <Form.Item
            label={
                <span className="file-type-name">
                    {t('FILE TYPE')} <span className="file-type-star">*</span>
                </span>
            }
            name="fileType"
            rules={[{ required: true, message: t('Please select file type') }]}
        >
            <Select value={selectedType}  onChange={(value, option) => handleChange(value, option)}>
                {fileDetails.map((item) => (
                    <Option key={item.docft_id} value={item.docft_id}>
                        {item.docft_desc}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
};

export default ConsentFileSelector;
